<template>
    <div class="bg-grey" @click.self="toParent" v-if="!show">
        <mt-picker :slots="slots2" ref="slot2" @change="onValuesChange" value-key="value"  showToolbar>
            <mt-header title="选择学校">
                <mt-button slot="left" class="cancle" @click="toParent">取消</mt-button> 
                <mt-button slot="right" class="sure" @click="sure">确定</mt-button>                       
            </mt-header>
        </mt-picker> 
    </div>
</template>
<script>
export default {
    data(){
        return{
            result: '',
            lastCityObj: null,
            schoolValue: '',
            schoolArray: [],
            oldValue: null,
            slots2: [{
                    flex: 1,
                    values: this.areas,
                    className: 'slot1',
                    textAlign: 'left',
                    defaultIndex: 0
                }, {
                    flex: 2,
                    values: [],
                    className: 'slot2',
                    textAlign: 'left',
                    defaultIndex: 0            
                }]
        }
    },
    props: ['show', 'areas'],
    methods: {
        // 筛选器值变化时调用
        onValuesChange(picker, values) {
            var _this = this;
            if(values[0]){
                if(!_this.oldValue||_this.oldValue.AreaID != values[0].AreaID){
                    _this.oldValue = values[0];
                    _this.$indicator.open('加载中...');
                    _this.abp.api.GetSchoolsOfArea(values[0].AreaID)
                    .then(res => {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                res.data.Data.forEach(ele => {
                                    ele.value = ele.FullName;
                                })
                                _this.schoolArray = res.data.Data;
                                picker.setSlotValues(1, res.data.Data);
                                if(res.data.Data.length == 0) {
                                    _this.abp.api.reqSuccess(_this,'本地区暂无学校,请联系管理员添加')
                                }
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
                }
            }
            var result = this.result;
            
            if(typeof(values[1]) == 'object'){
                result = values[1].value;
                this.schoolValue = values[1];
                for(var j=0; j<_this.schoolArray.length; j++){
                    if(this.schoolValue.ID == _this.schoolArray[j].ID){
                        this.second = j;
                    }
                }
                this.slots2[1].defaultIndex = parseInt(this.second);
            }
            this.result = result;
        },
        // 传值
        toParent(){
            var show = false;
            var result, school;
            // result = this.result;
            // school = this.schoolValue;
            this.$emit('changeValue', {show, result, school});
        },
        // 点击确定按钮
        sure(){
            var show = false;
            var result = this.result;
            var school = this.schoolValue;
            this.$emit('changeValue', {show, result, school});
        }
    }
}
</script>
<style scoped>
    .bg-grey{
        background: rgba(0,0,0,.5);
        position: fixed;
        z-index: 111;
        height: 100%;
        top: 0;
        right: 0;
    }
    .picker{
        position: fixed;
        bottom: 0;
        background: #fff;
        right: 0;
    }
    @media (max-width: 768px) {
        .bg-grey{
            left: 0;
        }
        .picker{
            left: 0;
        }
    }
    @media (min-width: 768px) {
        .bg-grey{
            left: 230px;
        }
        .picker{
            left: 230px;
        }
    }
    .mint-header{
        background: #f7f7f8;
        color: #333;
    }
    .cancle{
        color: #999;
    }
    .sure{
        color: #0575f2;
    }
</style>


